export default __webpack_public_path__ + "static/media/govern 1.cd047410.svg";